export default [
  'delete',
  'mergeSelected',
  'startSearch'
]
